import React, { useEffect, useState, UIEvent } from 'react';

import { useForm } from 'react-hook-form';

import { isCompareEqualsValues } from 'helpers';
import { useTracking } from 'hooks';

import type { ChangeEmail } from 'domains/change-cadastral';

export const useChangeEmailForm = () => {
  const [canSubmit, setCanSubmit] = useState(false);
  const [isInvalidForm, setIsInvalidForm] = useState(false);
  const [isDivergentFields, setIsDivergentFields] = useState(false);
  const { register, handleSubmit, getValues, watch } = useForm<ChangeEmail>();
  const { sendDataToGTM } = useTracking();

  const handleTracking = (
    event: React.FocusEvent<HTMLInputElement> | UIEvent<HTMLButtonElement>
  ) => {
    const {
      currentTarget: { dataset },
    } = event;

    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: dataset.eventname,
        cd_interaction_detail: dataset.title,
      },
    });
  };

  useEffect(() => {
    const subscription = watch((value) => {
      const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!value.email || !value.emailConfirmation) {
        setIsInvalidForm(true);
        setCanSubmit(false);
        setIsDivergentFields(true);
        return;
      }

      if (!isCompareEqualsValues(value.email, value.emailConfirmation)) {
        setIsInvalidForm(true);
        setCanSubmit(false);
        setIsDivergentFields(true);
        return;
      }

      if (!emailRegex.test(value.email) || !emailRegex.test(value.emailConfirmation)) {
        setIsInvalidForm(true);
        setCanSubmit(false);
        setIsDivergentFields(false);
        return;
      }

      setIsInvalidForm(false);
      setCanSubmit(true);
      setIsDivergentFields(false);
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  return {
    canSubmit,
    isInvalidForm,
    isDivergentFields,
    handleTracking,
    handleSubmit,
    register,
    toggleSubmit: setCanSubmit,
    toggleInvalidForm: setIsInvalidForm,
    getValues,
  };
};
